import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-bib-record-dialog',
  templateUrl: './bib-record-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BibRecordDialog {
  reply1: any = 'yes';
  reply2: any = 'no';

  constructor(
    public dialogRef: MatDialogRef<BibRecordDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  saveData() {
    this.dialogRef.close('yes');
  }
}
